<template>
  <modal name="terminal-modal" height="auto" width="400px" :scrollable="true">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('terminal-modal')"  alt="">
    </div>
    <div class="modal-address">
      <div class="title">Транспортная компания</div>
      <app-select :options="transport_companies" :loading="loading" :value="transport_company" @input="selectCompany($event)" placeholder="Компания"/>
      <div>
        <div class="title">Терминал</div>
        <app-select :options="transport_terminals" :loading="loading2" :search="true" :value="transport_terminal" @input="selectCompanyTerminal($event)" placeholder="Терминал"/>
      </div>
      <div>
        <div class="title">Адрес</div>
        <app-select :options="transport_addresses" :loading="loading3" :value="select_address" v-validate="'required'" data-vv-as="отделение" name="select_address" @input="select_address = $event" placeholder="Адрес"/>
        <span class="text-danger text-sm address-error">{{ errors.first('select_address') }}</span>
      </div>
      <div class="btn">
        <button @click="addTerminal()">Сохранить</button>
      </div>
    </div>
  </modal>
</template>

<script>
import AppSelect from "@/components/app-select";

export default {
  name: "provider-terminal-modal",
  components: {AppSelect},
  data: ()=> ({
    transport_companies: [],
    transport_company: '',
    transport_terminals: [],
    transport_terminal: '',
    transport_addresses: [],
    select_address: '',
    loading: true,
    loading2: false,
    loading3: false,
    id: '',
    company: '',
    terminal: '',
    address: '',
    warehouse_id: '',
    exclude: []
  }),
  methods: {
    open(terminal = null, companies = null){
      if (terminal) {
        this.id = terminal.id;
        this.company = terminal.address.name;
        this.terminal = terminal.address.terminal;
        this.address = terminal.address.address;
        this.warehouse_id = terminal.warehouse_id;
        this.exclude = [];
      } else {
        this.id = '';
        this.company = '';
        this.terminal = '';
        this.address = '';
        this.transport_terminals = [];
        this.transport_addresses = [];
        this.transport_company = '';
        this.transport_terminal = '';
        this.select_address = '';
        this.warehouse_id = '';

        if (companies.length > 0) {
          for (let key in companies) {
            this.exclude.push(companies[key].address.name);
          }
        }
      }
      this.$modal.show('terminal-modal'),
      this.getCompanies();
    },
    getCompanies() {
      this.transport_companies = [];
      this.$http.post('/get-transport-companies', {
        token: localStorage.getItem('token'),
        exclude: this.exclude
      }).then(({data}) => {
        if (data.transport_companies) {
          for (let key in data.transport_companies) {
            if (this.company) {
              if (this.company == data.transport_companies[key].name) {
                this.transport_companies.push({
                  label: data.transport_companies[key].name
                });
                this.transport_company = {
                  label: data.transport_companies[key].name
                };
                this.selectCompany(this.transport_company);
              }
            } else {
              this.transport_companies.push({
                label: data.transport_companies[key].name
              });
            }
          }
        }
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.loading = false;
      })
    },
    selectCompany(val) {
      this.transport_company = val;
      this.transport_terminals = [];
      this.transport_addresses = [];
      this.select_address = '';
      this.transport_terminal = '';
      this.loading2 = true;
      this.$http.post('/get-transport-terminals', {
        token: localStorage.getItem('token'),
        company: this.transport_company.label
      }).then(({data}) => {
        if (data.transport_companies) {
          for (let key in data.transport_companies) {
            this.transport_terminals.push({
              label: data.transport_companies[key].terminal
            });

            if (this.terminal && this.terminal == data.transport_companies[key].terminal) {
              this.transport_terminal = {
                label: data.transport_companies[key].terminal
              };
              this.selectCompanyTerminal(this.transport_terminal);
            }
          }
        }
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.loading2 = false;
      })

    },
    selectCompanyTerminal(val) {
      this.transport_terminal = val;
      this.transport_addresses = [];
      this.select_address = '';
      this.loading3 = true;
      if (this.transport_company.label == 'ПЭК') {
        this.$http.post('/get-pec-warehouses', {
          token: localStorage.getItem('token'),
          terminal: this.transport_terminal.label
        }).then(({data}) => {
          if (data.warehouses) {
            this.transport_addresses = data.warehouses;

            console.log(this.warehouse_id);

            for (let key in data.warehouses) {
              if (this.warehouse_id && this.warehouse_id == data.warehouses[key].id) {
                this.select_address = data.warehouses[key];
              }
            }

          }
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          this.loading3 = false;
        })
      } else {
        this.$http.post('/get-transport-addresses', {
          token: localStorage.getItem('token'),
          company: this.transport_company.label,
          terminal: this.transport_terminal.label
        }).then(({data}) => {
          if (data.transport_companies) {
            for (let key in data.transport_companies) {
              this.transport_addresses.push({
                id: data.transport_companies[key].id,
                label: data.transport_companies[key].address
              });
            }

            if (data.transport_companies.length == 1) {
              this.select_address = {
                id: data.transport_companies[0].id,
                label: data.transport_companies[0].address
              };
            }
          }
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          this.loading3 = false;
        })
      }
    },
    addTerminal() {
      this.$validator.validateAll()
          .then(success=>{
            if(success){
              this.$http.post('/add-provider-terminal', {
                token: localStorage.getItem('token'),
                address: this.select_address ? this.select_address.id : '',
                warehouse_address: this.select_address ? this.select_address.label : '',
                terminal: this.transport_terminal.label,
                company: this.transport_company.label,
                id: this.id
              }).then(({data}) => {
                if (data.success) {
                  this.$toast.success(this.id ? 'Терминал успешно изменен!' : 'Терминал успешно добавлен!');
                  this.$modal.hide('terminal-modal');
                  this.$emit('saved', '');
                }
              }).catch((error) => {
                console.log(error)
              })
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">

.w20 {
  width: 20%;
}

.w45 {
  width: 56%;
}
.top{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  &__title{
    display: flex;
    flex-wrap: wrap;
    .name{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #2D3137;
      margin-right: 30px;
    }
    .status{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #2CB181;
    }
    &-radio{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      width: max-content;
      background-color: white;
      border-radius: 4px;
      border: 1px solid #EEF0F3;

      &-item {
        cursor: pointer;
        padding: 10px 15px;
        margin: 2px;
        color: #7A818F;
      }
      &-item.active {
        color: #2D3137;
        background: #EEF0F3;
        border-radius: 4px;
      }
    }
  }
}
.btn{
  width: 100%;
  padding: 0;
  margin-top: 15px;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 20px;
}

.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
.checkbox {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin: 10px 0 12px 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #7A818F;
}
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  box-shadow: 0px 0px 3px #E5E5EA;
  border-radius: 4px;
}
.checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}
.checkbox input:checked ~ .checkmark {
  background-color: #ccc;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.checkbox input:checked ~ .checkmark:after {
  display: block;
}
.checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

textarea {
  height: 116px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding: 10px;
  width: 100%;
  height: 80px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
